import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es.object.from-entries.js";
import { compose, borders, color, flexbox, grid, layout, position, shadow, space, typography, opacity } from 'styled-system';
var systemPropsFns = compose(borders, color, flexbox, grid, layout, position, shadow, space, typography, opacity);
var allSystemProps = systemPropsFns.propNames;
var OMITTED_SYSTEM_PROPS = ["size"];
var systemProps = allSystemProps == null ? void 0 : allSystemProps.filter(function (prop) {
  return !OMITTED_SYSTEM_PROPS.includes(prop);
});

var isSystemProp = function isSystemProp(prop) {
  return systemProps == null ? void 0 : systemProps.includes(prop);
};

var getSystemProps = function getSystemProps(props) {
  return Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var key = _ref[0];
    return isSystemProp(key);
  }));
};

var omitSystemProps = function omitSystemProps(props) {
  return Object.fromEntries(Object.entries(props).filter(function (_ref2) {
    var key = _ref2[0];
    return !isSystemProp(key);
  }));
};

export { allSystemProps, getSystemProps, omitSystemProps, systemProps, systemPropsFns };